module.exports = __webpack_public_path__ + "img/2.ee44823e.jpg";